import { HttpStatusCode } from "axios";
import subStepService from "../../apiServices/freshman/subStepService";
import { alertConstants } from "../../helper/sweet-alert";
import { setKeyValuePair, setSubStep, setSubSteps } from "../../store/slices/freshman/subStepSlice";

export function getSubStep(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.getSubStep(id);
    if (response?.success === true) {
      dispatch(setSubStep(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getSubSteps(includeInactive?: boolean) {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.getSubSteps(includeInactive);
    if (response?.success === true) {
      dispatch(setSubSteps(response.data));
    } else {
      console.log("error");
    }
  };
}


export function createSubStep(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.createSubStep(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        const name = data.name
        callback(alertConstants.conflict, undefined, undefined, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateSubStep(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.updateSubStep(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function inactivateSubStep(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.inactivateSubStep(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}

export function getAllSubStepsKeyValuePair() {
  return async function (dispatch: any, getState: any) {
    let response = await subStepService.getAllSubStepsKeyValuePair();
    if (response?.success === true) {
      dispatch(setKeyValuePair(response.data));
    } else {
      console.log("error");
    }
  };
}